export default "__VITE_ASSET__CqQyM2Mp__"